// File generated by PostBuildApiClientController
import { HttpApiClient } from "./HttpApiClient";
import { HttpApiRequestOptions } from "./HttpApiRequestOptions";
import { Injectable } from "@angular/core";
import { TemplateGenericDto } from "../../../../../libs/utils/ng-shared-components/src/lib/templates/dtos/TemplateGenericDto";

@Injectable({providedIn: 'root'})
export class ApiTemplateGeneric {
  constructor(private _httpApiClient: HttpApiClient) {
    // Empty constructor
  }

  create(
    templateGenericDto: TemplateGenericDto,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<TemplateGenericDto> {
    return this._httpApiClient.post("/shared/template/generic", templateGenericDto, httpApiRequestOptions);
  }

  edit(
    templateGenericDto: TemplateGenericDto,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<TemplateGenericDto> {
    return this._httpApiClient.put("/shared/template/generic", templateGenericDto, httpApiRequestOptions);
  }

  getById(
    id: string,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<TemplateGenericDto> {
    return this._httpApiClient.get("/shared/template/generic/" + id, httpApiRequestOptions);
  }

}
